import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { BModal } from 'bootstrap-vue';
import TemplateRelationDetailsModalItem from './item/TemplateRelationDetailsModalItem.vue';
import { ITemplateRelationDetails, IProduct } from '@/typings/templateRelationDetails/templateRelationDetails';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateRelationDetailsModal',
  props: {
    templateRelationDetails: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
    templateRelationDetails: ITemplateRelationDetails;
};





const iFrameUrl = process.env.VUE_APP_SHOPIFY_APP_URL;
const customilyBaseUrl = process.env.VUE_APP_CUSTOMILY_BASE_URL;

const getTitle = computed((): string => {
    return props.templateRelationDetails?.title;
});

const getProducts = computed(() => {
    return props.templateRelationDetails.Products.map((item) => {
        const client = props.templateRelationDetails?.Clients?.find((client) => client.client_id === item.client_id);
        return {
            title: item.product_title,
            src: item.image_src,
            published: item.published,
            active: item.active,
            url: `${customilyBaseUrl}/store/product?product=${item.sp_product_id}&shop=${client?.client_actual_domain}`,
            childrens: getOptionSetsAndVariants(item)
        };
    });
});

const getOptionSetsAndVariants = (item: IProduct) => {
    const client = props.templateRelationDetails?.Clients?.find((client) => client.client_id === item.client_id);
    const productUrl = `${customilyBaseUrl}/store/product?product=${item.sp_product_id}&shop=${client?.client_actual_domain}`;

    const variations = [];

    // Option level functions: the template is assigned to an option value (ie. Size > S)
    for (const variation of item?.configuration?.variations || []) {
        if (!variation.values?.length) {
            continue;
        }

        for (const value of variation.values) {
            if (value.product_id === null || value.product_id !== props.templateRelationDetails?.templateId) {
                continue;
            }
            variations.push({
                title: `${variation.name} > ${value?.value || 'N/A'}`,
                url: productUrl,
                type: 'variant'
            });
        }
    }

    // Variant level functions: the template is assigned to a variant combination (ie. azul / S / Algodon)
    for (const confVariant of item?.configuration?.conf_variants || []) {
        for (const confVariantFunction of confVariant.functions || []) {
            if (confVariantFunction.function?.type !== 'product') {
                continue;
            }
            if (confVariantFunction.value?.product_id !== props.templateRelationDetails?.templateId) {
                continue;
            }
            const title =
                confVariant.title ||
                [confVariant.option1, confVariant.option2, confVariant.option3].filter(Boolean).join(' / ');
            variations.push({
                title: title || 'N/A',
                url: productUrl,
                type: 'variant'
            });
        }
    }

    const optionSets = (item.configuration?.assignedSets || []).map((assignedSet) => {
        const optionSet = props.templateRelationDetails.OptionSets?.find(
            (optionSet) => optionSet.optionset_internal_id === assignedSet.id
        );
        if (!optionSet) {
            return [];
        }
        return (optionSet.options || []).map((option) => ({
            title: `${optionSet.optionset_name} > ${option.option_label ?? 'N/A'}`,
            url: `${iFrameUrl}/set?set=${optionSet.optionset_internal_id}`,
            type: 'option'
        }));
    });

    const flattenedOptionSets = optionSets.flat();

    return variations.concat(flattenedOptionSets);
};

const onCloseHandler = () => {
    emit('close');
};

return { __sfc: true,props, emit, iFrameUrl, customilyBaseUrl, getTitle, getProducts, getOptionSetsAndVariants, onCloseHandler, BModal, TemplateRelationDetailsModalItem }
}

})